import wrap from "./wrap-root-element";
export const wrapRootElement = wrap;
if (typeof wrapRootElement !== 'undefined' && wrapRootElement && wrapRootElement === Object(wrapRootElement) && Object.isExtensible(wrapRootElement) && !Object.prototype.hasOwnProperty.call(wrapRootElement, '__filemeta')) {
  Object.defineProperty(wrapRootElement, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapRootElement",
      filename: "node_modules/gatsby-plugin-mdx/gatsby-browser.js"
    }
  });
}